import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { TransactionInfo } from './components';
import { AccountPreview, ProductPreview, SlotPreview, StudentPreview, BookingPreview, ItemClassPreview, InventoryPreview } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    marginBottom: theme.spacing(3),
  }
}));

const Summary = props => {
  const { className, handleDelete, reload, ...rest } = props;
  const model = useSelector(state => state.models.transaction);

  const classes = useStyles();

  if (!model) {
    return null;
  }
  const {item, inventory} = model.data
  return (
    <Grid {...rest} className={clsx(classes.root, className)} container spacing={3}>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <TransactionInfo className={classes.card} />
        {item && <ItemClassPreview itemClassId={item} className={classes.card} />}
        {inventory && <InventoryPreview inventoryId={inventory} className={classes.card} />}
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        {model.data.product && <ProductPreview productId={model.data.product} />}
        <AccountPreview accountId={model.account.id} />
        {model.booking && model.booking.student && <StudentPreview student={model.booking.student} />}
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        {model.booking && model.booking.lesson_slot && <SlotPreview slot={model.booking.lesson_slot} />}
        {model.booking && <BookingPreview booking={model.booking} />}
      </Grid>
    </Grid>
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
